import { FilterOps, NestedFilterInput } from '@@types'

/**
 * Map UI/URL filter values to API filter values
 * Naming convention:
 *   <field>_<operator>: value
 * Where operator can be _to or _from, for example price_from: 10, price_to: 100
 * We are assuming that all filter values are strings or numbers
 */
const mapFiltersToApi = (filters: Record<string, unknown>): NestedFilterInput => {
  const conditions: NestedFilterInput[] = []

  for (const [ key, value ] of Object.entries(filters)) {
    if (value === undefined || value === null || value === '') continue
    if (typeof value !== 'string' && typeof value !== 'number' && !Array.isArray(value)) continue

    if (key.endsWith('_from')) {
      const field = key.replace('_from', '')
      conditions.push({
        fields: [ field ],
        value,
        op: FilterOps.GREATER,
      })
    }
    else if (key.endsWith('_to')) {
      const field = key.replace('_to', '')
      conditions.push({
        fields: [ field ],
        value,
        op: FilterOps.LESS,
      })
    }
    else {
      conditions.push({
        fields: [ key ],
        value,
        op: FilterOps.CONTAINS,
      })
    }
  }

  return {
    and: conditions,
  }
}

export { mapFiltersToApi }
